var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover",
          value: {
            disabled: !_vm.title,
            title: _vm.title,
            placement: _vm.tooltipPlacement,
          },
          expression:
            "{ disabled: !title, title, placement: tooltipPlacement }",
          modifiers: { hover: true },
        },
      ],
      staticClass:
        "ml-2 d-inline-flex align-items-center justify-content-center",
    },
    [
      _vm.loading
        ? _c("div", {
            staticClass: "ld ld-ring ld-spin-fast mini",
            class: _vm.iconClass,
            staticStyle: {
              width: "1em !important",
              height: "1em !important",
              "font-size": "0.9em !important",
            },
          })
        : _c("i", {
            staticClass: "fa fa-refresh clickable",
            class: _vm.iconClass,
            staticStyle: { "font-size": "1em" },
            on: { click: _vm.handleRefresh },
          }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }